import { ChangeDetectionStrategy, Component, inject, TemplateRef } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { BehaviorSubject, of } from 'rxjs';

import {
  RouteTabGroupComponent,
  TabGroupConfig,
} from '@features/tab-group/route-tab-group.component';

import { ROUTING_PATH } from '@shared/constants/routingPath';
import { LaunchDarklyService } from '@shared/services/launch-darkly.service';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouteTabGroupComponent, RouterOutlet],
  selector: 'aux-account',
  templateUrl: './account.component.html',
})
export class AccountComponent {
  private launchDarklyService = inject(LaunchDarklyService);

  rightSideContainer = new BehaviorSubject<null | TemplateRef<unknown>>(null);
  tabs: TabGroupConfig[] = [
    {
      label: 'Profile & Settings',
      route: ROUTING_PATH.ACCOUNT.SETTINGS,
      show: this.launchDarklyService.select$((flags) => flags.tab_profile_settings),
    },
    {
      label: 'Notification Preferences',
      route: ROUTING_PATH.ACCOUNT.NOTIFICATIONS,
      show: of(true),
    },
  ];
}
